import React from "react";
import { useAuth } from "../../Auth/AuthContext/AuthContext";

const LoginButton = ({ onLogout }) => {
  const { isAuthenticated, logout } = useAuth();
  const API_URL = process.env.REACT_APP_API_URL;


  const handleLogin = () => {
    window.location.href = `${API_URL}/auth/login`;
  };

  const handleLogout = () => {
    logout();
    if (onLogout) onLogout(); // Executa o callback passado
  };

  return (
    <button
      onClick={isAuthenticated ? handleLogout : handleLogin}
      className={`px-6 py-2 w-full font-semibold rounded-lg shadow transition ${
        isAuthenticated
          ? "bg-red-600 text-white hover:bg-red-700"
          : "bg-blue-600 text-white hover:bg-blue-700"
      }`}
    >
      {isAuthenticated ? "Logout" : "Login com Microsoft"}
    </button>
  );
};

export default LoginButton;
